import styled from '@emotion/styled';
import { FeaturedJob } from 'rwl-shared/dist/models';
import { formatDateRange } from '@realwork/crux-utils/date';
import { getJobDescription } from '../../../utils';
import { ReviewRating, Subtitle2 } from 'rwl-ui';
import { When } from 'react-if';

const JobTitle = styled(Subtitle2)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
    padding-bottom: var(--rwl-spacing-sm);
`;

export const JOB_DETAILS_HEIGHT = 120;
const JobDetailsContainer = styled.div`
    padding: var(--rwl-spacing-md);
    height: ${JOB_DETAILS_HEIGHT}px;
`;

const JobDescriptionContainer = styled.p`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: 'ellipsis';
    margin: 0;
    color: var(--rwl-palette-warmGray-500);
    height: 40px;
`;

const JobDateAndRatingContainer = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    text-overflow: 'ellipsis';
    padding-bottom: var(--rwl-spacing-sm);
    justify-content: space-between;
`;

const JobDateColumn = styled.div`
    display: flex;
    overflow: hidden;
    text-overflow: 'ellipsis';
`;

const JobReviewColumn = styled.div`
    display: flex;
    overflow: hidden;
    text-overflow: 'ellipsis';
`;

export const JobCardDetails = ({ job }: { job: FeaturedJob }) => {
    const description = getJobDescription(job);

    return (
        <JobDetailsContainer>
            <JobTitle className="rwl-card-title">{job.title}</JobTitle>
            <JobDateAndRatingContainer className="rwl-body-2">
                <JobDateColumn>
                    {job.startedAt
                        ? formatDateRange(new Date(job.startedAt))
                        : ''}
                </JobDateColumn>
                <When condition={job.reviewSource && job.reviewRating}>
                    <JobReviewColumn>
                        <ReviewRating
                            size="small"
                            rating={job.reviewRating!}
                            source={job.reviewSource}
                        />
                    </JobReviewColumn>
                </When>
            </JobDateAndRatingContainer>
            <JobDescriptionContainer className="rwl-body-2">
                {description}
            </JobDescriptionContainer>
        </JobDetailsContainer>
    );
};
